<template>
  <block-view class="wechat-merchant-seg-view">
    <a-flex vertical>
      <a-typography-title :level="5">收款商户</a-typography-title>
      <a-flex vertical align="center" class="wmsv-content">
        <img src="@/assets/image/wepay_icon.png" alt=""/>
        <a-typography-title :level="4">独立微信支付</a-typography-title>
        <a-typography-text type="secondary">
          开设独立的微信支付收款账户，关联与主体信息一致的银行对公账户，个体工商可关联法人个人银行卡，资金由微信支付官方提供清分处理，安全有保障！
        </a-typography-text>
        <router-link to="/account/merchant">
          <a-button type="primary" shape="round">
            快速申请
          </a-button>
        </router-link>
      </a-flex>
    </a-flex>
  </block-view>
</template>

<script setup lang="ts">

import BlockView from "@/views/share/BlockView.vue";
</script>

<style scoped lang="sass">
.wechat-merchant-seg-view
  background-image: url("@/assets/image/wepay_bg.png")
  background-size: cover
  background-repeat: no-repeat

  .wmsv-content
    > img
      display: block
      width: 30%

    > a > button
      background-color: #09BE4F
      margin: 18px 0 -6px 0
      width: 140px
</style>